import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, BookOpen, Store, GraduationCap, Award, Users, Hammer, LogOut, BarChart3 } from "lucide-react";

export default function Sidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const isCreator = user?.role === "instructor" || user?.role === "org_admin" || user?.role === "super_admin";

  const links = [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
    { to: "/learning", label: "My Learning", icon: GraduationCap, testid: "nav-learning" },
    { to: "/courses", label: "Courses", icon: BookOpen, testid: "nav-courses" },
    { to: "/marketplace", label: "Marketplace", icon: Store, testid: "nav-marketplace" },
    { to: "/certificates", label: "Certificates", icon: Award, testid: "nav-certificates" },
  ];
  if (isCreator) links.push({ to: "/builder", label: "Course Builder", icon: Hammer, testid: "nav-builder" });
  if (isCreator) links.push({ to: "/creator-analytics", label: "Reach & Stats", icon: BarChart3, testid: "nav-creator-analytics" });
  if (user?.role === "org_admin") {
    links.push({ to: "/licenses", label: "Licenses", icon: Users, testid: "nav-licenses" });
    links.push({ to: "/analytics", label: "Team Analytics", icon: BarChart3, testid: "nav-analytics" });
  }
  if (user?.role === "org_admin") links.push({ to: "/organization", label: "Organization", icon: Users, testid: "nav-organization" });

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <aside className="bg-[#0A0A0A] text-white w-64 min-h-screen flex flex-col fixed left-0 top-0" data-testid="sidebar">
      <div className="px-6 py-7 border-b border-zinc-800">
        <NavLink to="/dashboard" className="flex items-baseline gap-1" data-testid="sidebar-logo">
          <span className="font-serif text-3xl font-light tracking-tighter">Forge</span>
          <span className="text-[#E63946] text-xl leading-none">.</span>
        </NavLink>
        <div className="overline mt-2 text-zinc-500">Learning Platform</div>
      </div>
      <nav className="flex-1 py-5">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            data-testid={l.testid}
            className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
          >
            <l.icon size={17} strokeWidth={1.5} />
            <span>{l.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-zinc-800 px-5 py-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-9 h-9 bg-[#E63946] flex items-center justify-center font-display font-bold text-sm" data-testid="user-avatar">
            {user?.name?.[0]?.toUpperCase() || "?"}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-display truncate" data-testid="user-name">{user?.name}</div>
            <div className="overline text-zinc-500 truncate">{user?.role?.replace("_", " ")}</div>
          </div>
        </div>
        <button onClick={handleLogout} data-testid="logout-button" className="w-full flex items-center gap-2 text-sm text-zinc-400 hover:text-white py-2 transition-colors">
          <LogOut size={15} strokeWidth={1.5} /> Sign out
        </button>
      </div>
    </aside>
  );
}
